<template>
  <div class="listNotation">
    <div class="screening">
      <el-popover placement="bottom-start" popper-class="popperStyle" width="150" trigger="click" >
        <el-checkbox-group size="medium" v-model="source" @change="sureSelect">
          <el-checkbox label="1">我的创建</el-checkbox>
          <!-- <el-checkbox label="2">我的修改</el-checkbox> -->
        </el-checkbox-group>
        <el-button slot="reference" class="screenSource" type="text" >数据来源<i class="el-icon-arrow-down"></i ></el-button>
      </el-popover>
      <el-button type="text" class="screenSource" @click="sortData"
        >排序<i :class="[sortUp ? 'el-icon-sort-up' : 'el-icon-sort-down']"></i
      ></el-button>
      <el-popover placement="bottom-start" popper-class="popperStyle" width="150" trigger="click" >
        <el-checkbox-group size="medium" v-model="queryForm.qmstatus" @change="sureSelect" >
          <el-checkbox v-for="item in statusList" :label="item.id" :key="item.id"
            >{{ item.name }}</el-checkbox >
        </el-checkbox-group>
        <el-button slot="reference" class="screenSource" type="text" >状态<i class="el-icon-arrow-down"></i ></el-button>
      </el-popover>
      <el-button type="text" class="screenSource" @click="moreSelect"
        >高级筛选<i :class="[selectBoolean ? 'el-icon-arrow-up' : 'el-icon-arrow-down']" ></i
      ></el-button>
      <!-- <img src="../../question/images/images/dwxs.png" class="markShow" alt="显隐锚点"
        v-if="markBoolean" @click="changedwxs" title="点击隐藏全部" /> -->
      <!-- <img src="../../question/images/images/dwyc.png" class="markShow" alt="显隐锚点"
        v-else @click="changedwxs" title="点击显示全部" /> -->
    </div>
    <div class="search" v-if="!selectBoolean">
      <el-input v-model="queryForm.qualityName" size="small" placeholder="请输入流程名称" suffix-icon="el-icon-search" @input="sureSelect" >
      </el-input>
      <i class="el-icon-refresh-right" @click="update"></i>
      <!-- <img src="../../question/images/daochu.png" alt="导出问题列表" @click="exportExcel" title="导出问题列表" /> -->
    </div>
    <!-- 问题列表 -->
    <div class="list" v-if="!selectBoolean" v-loading="loading" element-loading-text="数据获取中" >
      <ul class="infinite-list" :infinite-scroll-immediate="false" :infinite-scroll-delay="500" v-infinite-scroll="load" style="overflow: auto" >
        <li v-for="item in nolist" class="infinite-list-item" :key="item.qualityId"
          :class="{ active: activeIndex == item.qualityId }">
          <div class="top" v-if="type == 'rvt'">
            <span :class="{ status1: item.qmstatus == '已延期', status2: item.qmstatus == '进行中', status3: item.qmstatus == '已完成', }"
                class="status">【{{ item.qmstatus }}】</span >
            <span class="text" :title="item.qualityName">{{ item.qualityName }}</span>
            <span class="right">
              <img :src="dingwei" alt="定位" @click.stop="aim(item)" />
              <img :src="shanchu" alt="删除" @click.stop="delannotation(item.qualityId)" />
            </span>
          </div>
          <div class="down">
            <span class="detailname">创建人:</span>
            <span :title="item.createUserName" class="modifierName">{{ item.createUserName }}</span>
            <span class="detailname">创建时间:</span>
            <span> {{ item.startDate}} </span>
          </div>
        </li>
      </ul>
    </div>
    <!-- 高级查询 -->
    <div class="select" v-else>
      <el-form ref="queryForm" :model="queryForm" label-position="top" label-width="86px" size="mini" >
        <el-form-item label="状态:">
          <el-checkbox-group v-model="queryForm.qmstatus">
            <el-checkbox v-for="(item, index) in statusList" :label="item.id" :key="index" >{{ item.name }} </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="流程类型:">
          <el-checkbox-group v-model="queryForm.processTypeIds">
            <el-checkbox v-for="(item, index) in flowTypeList" :label="item.id" :key="index" >{{ item.name }} </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="创建人:" filterable>
          <el-select  v-model="queryForm.createUserName" placeholder="请选择创建人" clearable filterable >
            <el-option v-for="(item, index) in dicList.createUserList" :key="index" :label="item.name" :value="item.name" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间:">
          <el-date-picker ref="startDateRef" v-model="queryForm.startDate" value-format='yyyy-MM-dd' 
            format='yyyy-MM-dd' type="date" placeholder="选择日期" >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="数据来源:">
          <el-select v-model="queryForm.sourceList" placeholder="请选择数据来源" multiple >
            <el-option v-for="(item, index) in dicList.problemSourceList" :key="index" :label="item.cnName" :value="item.cnName" ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div class="footer">
        <el-button size="mini" @click="chongzhi">重置</el-button>
        <el-button size="mini" title="应用" type="primary" @click="moreSureSelect" >应用</el-button >
      </div>
    </div>
  </div>
</template>

<script>
const queryFormParams = () => ({
  qmstatus: [], //状态
  qualityName:"",//流程名称
  createUserName: "", //创建人
  startDate: "", //创建开始时间
  endDate: "", //创建结束时间
  sourceList: [], //数据来源
  processTypeIds:[],//流程类型
});
import flowService from "@/CommonDP/service/flow-service";
import question from "@/xgzdService/question-service";
import { mapState } from "vuex";
import quaMangeService from '@/xgzdService/quaMange-service';
export default {
  props: ["type"],
  data() {
    return {
      prjID: "",
      fileId: "",
      source: [], //来源
      qmstatus: [], //状态
      dicList: {},
      sortUp: false, //排序
      markBoolean: true, //标记显隐
      selectBoolean: false, //高级筛选
      queryForm: queryFormParams(),
      pageNum: 1,
      pageSize: 20,
      totalPage: 1, //总页数
      pageData: [], //一页的数据
      nolist: [], //查看总数
      loading: false,
      dataRow: "",
      activeIndex: "",
      flowTypeList:[],
      statusList:[
        {name:"进行中",id:"1"},
        {name:"已延期",id:"2"},
        {name:"已完成",id:"3"},
      ],
      dingwei:require("@/views/question/images/dingwei.png"),
      shanchu:require("@/views/question/images/shanchu.png")
    };
  },
  computed: {
    ...mapState({
      modeldata: (state) => state.monge.modeldata,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo,
    }),
    queryParams() {
      console.log(this.source);
      const {endDate, startDate, qmstatus, createUserName, qualityName,processTypeIds} =this.queryForm;
      const createUser=this.source.length>0?this.userInfo.name:"";
      const params = {
        endDateBeginStr:endDate?endDate[0]:"",
        endDateEndStr:endDate?endDate[1]:"",
        startDateBeginStr:startDate?startDate[0]:"",
        startDateEndStr:startDate?startDate[1]:"",
        type:this.$route.query.noquaFlow,//0是质量管理1是安全管理
        qmstatus,
        createUserName:createUserName||createUser,
        qualityName,
        processTypeIds,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        prjId:this.$route.query.prjId,
        enterpriseId:this.enterpriseId,
      };
      return params;
    },
  },
  methods: {
    init() {
      if (!!this.modeldata.fileObj) {
        this.fileId = "";
        this.prjID = this.modeldata.prjId;
      } else {
        this.fileId = this.modeldata.fileId;
        this.prjID = this.modeldata.prjId;
      }
      
      this.queryDic();
      this.getFlowType()
      this.pageNum = 1;
      this.nolist = [];
      this.queryNotationList();
    },
    //查询时候的字典
    async queryDic() {
      const res = await question.getFilterDic(this.prjID);
      if (res.result === "0") {
        this.dicList = res.data || {};
      }
    },
    //创建流程的类型
    async getFlowType() {
      const res = await flowService.queryGroupInfoList(this.enterpriseId);
      if(this.$route.query.noquaFlow==="0"){
        this.flowTypeList=res.data.find(item=> item.flowGroupDto.name=="质量巡检")?.flowDefinitionDtoList
      }else if(this.$route.query.noquaFlow==="1"){
        this.flowTypeList=res.data.find(item=> item.flowGroupDto.name=="安全巡检")?.flowDefinitionDtoList
      }
    },
    moreSureSelect() {
      this.selectBoolean = !this.selectBoolean;
      this.sureSelect();
    },
    sureSelect() {
      this.pageNum = 1;
      this.nolist = [];
      this.queryNotationList();
    },
    //查询列表
    async queryNotationList() {
      this.pageData = [];
      this.loading = true;
      const fileIds=this.$route.query.fileIds?.split(",");
      try {
        const res = await quaMangeService.qualityGet(this.queryParams);
        if (res.result == "0") {
          this.pageData = res.data;
          this.totalPage = res.totalPage;
          const array = [...this.nolist, ...this.pageData];
          //先过滤掉没有模型的
          let list=array.filter(item=>{ return item.modelComponentRelaList.length>0 })
          this.nolist=list.map((item)=>{
            item.modelComponentRelaList.filter((ele)=>{
              return fileIds.some(f=>(f === ele.modelId)) 
            })
            return item
          })
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    load() {
      if (this.totalPage > this.pageNum) {
        this.pageNum++;
        this.queryNotationList();
      }
    },
    //刷新
    update() {
      this.pageNum = 1;
      this.nolist = [];
      this.queryNotationList();
    },
    //排序
    sortData() {
      this.sortUp = !this.sortUp;
      this.pageNum = 1;
      this.nolist = [];
      this.queryNotationList();
    },
    //高级筛选
    moreSelect() {
      this.selectBoolean = !this.selectBoolean;
      console.log(this.selectBoolean);
    },
    //标记显隐
    async changedwxs() {
      this.markBoolean = !this.markBoolean;
      
    },
  
    //导出问题列表
    exportExcel() {
      this.queryParams.pageNum = 0;
      this.queryParams.pageSize = 0;
      question.drawingDrawingQuesExport(this.queryParams).then((response) => {
        const fileName = "批注列表.xlsx";
        if ("msSaveOrOpenBlob" in navigator) {
          // 兼容ie
          // let blob = response
          window.navigator.msSaveOrOpenBlob(response, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = response;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.excelDisable = true;
          this.excelSelect = false;
        }
      });
    },
    //重置按钮
    chongzhi() {
      this.selectBoolean = !this.selectBoolean;
      this.queryForm = queryFormParams();
      this.pageNum = 1;
      this.nolist = [];
      this.queryNotationList();
    },
    closepop(id) {
      this.$refs[`popover${id}`][0].showPopper = false;
    },
    //删除单个批注
    delannotation(id) {
      this.$confirm("是否删除当前流程清单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await quaMangeService.delModelQua(id);
          if (res.result === "0") {
            this.$message({ type: "success", message: "删除成功!" });
            this.pageNum = 1;
            this.nolist = [];
            this.queryNotationList();
          }
        })
        .catch(() => {
          // this.$message({ type: "info", message: err.message || "无效" });
        });
    },
    async aim(item) {
      //先将存的modelId改为folderId，避免跟模型id冲突
      const modelComponentRelaList=item.modelComponentRelaList.map((ele)=>{
        return{
          folderId:ele.modelId,
          elementId:ele.componentId,
          modelId:""
        }
      });
      //获取当前打开模型的数据
      const options = Monge.Model.getModels();
      //通过关联的文件id，设置对应的模型id
      for(let i=0;i<modelComponentRelaList.length;i++){
        options.forEach(ele => {
          if(ele.url.bimexId === modelComponentRelaList[i].folderId){
            modelComponentRelaList[i].modelId=ele.id;
          }
        });
      };
      //组成模型对应数据
      const array=modelComponentRelaList.map((ele)=>{
        return{
          elementId:ele.elementId?.slice(16),
          modelId:ele.modelId
        }
      });
      Monge.Model.Selector.selectSingles(array)
    },
  },
};
</script>
<style lang="scss" scoped>
.listNotation {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .labelLogo {
    border: 0.6px solid #7a87a5;
    box-sizing: border-box;
    color: #606266;
    cursor: pointer;
    border-radius: 18px;
    font-size: 14px;
    line-height: 20px;
    padding: 0 4px;
    margin-right: 5px;
  }
  .labelLogo:hover {
    border: 0.6px solid #3873fe;
  }
  .labelLogo.active {
    border: 0.6px solid #3873fe;
    color: #3873fe;
  }
  // overflow-y: auto;
  .screening {
    width: 100%;
    height: 30px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .screenSource {
      color: #606266;
      padding: 0 !important;
      margin-right: 8px;
      font-size: 14px;
      /deep/span {
        font-size: 14px;
      }
    }
    .markShow {
      cursor: pointer;
    }
  }
  .logo {
    width: 100%;
    height: 30px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .name {
      font-size: 14px;
      line-height: 30px;
      user-select: none;
      color: #606266;
    }
  }
  .search {
    width: 100%;
    height: 40px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    i {
      font-size: 23px;
      color: #8692b0;
      margin-left: 4px;
      cursor: pointer;
    }
    img {
      margin-left: 4px;
      cursor: pointer;
    }
  }
  .list {
    border-top: 1px solid rgb(212, 217, 236);
    width: 100%;
    height: calc(100% - 90px);
    padding: 10px 0 10px 10px;
    .infinite-list {
      width: 100%;
      height: 100%;
      padding-right: 10px;
      .infinite-list-item {
        width: 100%;
        min-height: 76px;
        border-bottom: 1px solid rgb(212, 217, 236);
        border-radius: 4px;
        padding: 0 5px;
      }
      .active {
        background: #f3f6ff;
      }
      .infinite-list-item:hover {
        background: #f3f6ff;
      }
      .up {
        width: 100%;
        height: 38px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .checkContent {
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: top;
          width: calc(100% - 120px);
          user-select: none;
        }
        .right {
          margin-left: auto;
          display: flex;
          flex-direction: row;
          img {
            margin-right: 5px;
            cursor: pointer;
          }
        }
      }
      .top {
        width: 100%;
        // height: 20px;
        padding-top: 10px;
        padding-left: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .right {
          margin-left: auto;
          display: flex;
          flex-direction: row;
          img {
            margin-right: 5px;
            cursor: pointer;
          }
        }
      }
      .down {
        width: 100%;
        height: 38px;
        display: flex;
        flex-direction: row;
        align-items: center;
        span {
          font-size: 14px;
          line-height: 18px;
        }
        .detailname {
          color: #606266;
          margin-right: 5px;
          user-select: none;
        }
        .modifierName {
          overflow: hidden;
          text-overflow: ellipsis;
          user-select: none;
          white-space: nowrap;
          width: calc(100% - 220px);
          vertical-align: top;
          margin-right: 10px;
        }
      }
    }
    // overflow-y: auto;
  }
  .select {
    border-top: 1px solid rgb(212, 217, 236);
    width: 100%;
    padding-left: 5px;
    height: calc(100% - 30px);
    .el-form {
      padding: 10px 5px 10px 0;
      width: 100%;
      height: calc(100% - 50px);
      overflow-y: auto;
    }
    .footer {
      width: 100%;
      height: 50px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      padding-right: 20px;
    }

    /deep/.el-checkbox {
      margin-right: 5px;
    }
    /deep/.el-select,
    .el-date-editor {
      width: 100%;
    }
    /deep/.el-form-item {
      margin-bottom: 10px;
    }
  }
  .status {
    font-size: 14px;
    cursor: pointer;
  }
  .status1 {
    color: #eb5757;
  }
  .status2 {
    color: #27ae60;
  }
  .status3 {
    color: #4b6a8f;
  }
  .status4 {
    color: #8b8888;
  }
  .text{
    width: 120px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow:ellipsis
  }
}

</style>